import { render, staticRenderFns } from "./CreateCommentsWeekAndMonth.vue?vue&type=template&id=2eff7308&scoped=true"
import script from "./CreateCommentsWeekAndMonth.vue?vue&type=script&lang=js"
export * from "./CreateCommentsWeekAndMonth.vue?vue&type=script&lang=js"
import style0 from "./CreateCommentsWeekAndMonth.vue?vue&type=style&index=0&id=2eff7308&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eff7308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eff7308')) {
      api.createRecord('2eff7308', component.options)
    } else {
      api.reload('2eff7308', component.options)
    }
    module.hot.accept("./CreateCommentsWeekAndMonth.vue?vue&type=template&id=2eff7308&scoped=true", function () {
      api.rerender('2eff7308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/dialog/CreateCommentsWeekAndMonth.vue"
export default component.exports